export default __webpack_public_path__ + "static/18-6f3f888b947064ebb23c536fb14c5a96.png";